import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import AppEtapeNavigation from "src/commun/composants/formNavigation/AppEtapeNavigation";
import { useFinalisation } from "src/pages/finalisation/FinalisationContext";
import { FinalisationEtapes } from "src/pages/finalisation/hooks/useInitEtapesFinalisation";
import VerificationMailForm from "src/pages/finalisation/etapes/verificationMail/VerificationMailForm";
import { VerificationMail } from "src/pages/finalisation/etapes/verificationMail/codeMailSend/useValidationSchemaMail";
import VerificationTelephoneForm from "src/pages/finalisation/etapes/verificationTelephone/VerificationTelephoneForm";
import { VerificationTelephone } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneSend/useValidationSchemaTelephone";
import InfoPersoForm from "src/pages/finalisation/etapes/infoPerso/InfoPersoForm";
import { InfoPerso } from "src/pages/finalisation/etapes/infoPerso/useValidationSchemaInfoPerso";
import Finalisation from "src/pages/finalisation/etapes/finalisation/Finalisation";


const FinalisationForm = () => {
  const [value, api] = useFinalisation();
  const { tString } = useAppText();

  return  (
    <span className={`ferge-class`}>
      <div className={'mt-3'} />
      <AppEtapeNavigation
        titre={tString("migration.step.1.title")}
        etapes={value.etapes}
        setStateListe={api.setEtapes}
        contenu={({ etapeCourante, pageSuivante }) => {
          return (
            <div>
             {etapeCourante === FinalisationEtapes.Mail && (
                <VerificationMailForm
                  pageSuivante={pageSuivante}
                  initialValues={value.etapes[0].data as VerificationMail}
                />
              )}
              {etapeCourante === FinalisationEtapes.Telephone && (
                <VerificationTelephoneForm
                  pageSuivante={pageSuivante}
                  initialValues={value.etapes[1].data as VerificationTelephone}
                />
              )}
              {etapeCourante === FinalisationEtapes.InfoPerso && (
                <InfoPersoForm
                  pageSuivante={pageSuivante}
                  initialValues={value.etapes[2].data as InfoPerso}
                />
              )}
              {etapeCourante === FinalisationEtapes.Finalisation && (
                <Finalisation />
              )}
            </div>
          );
        }}
      />
    </span>
  );
};

export default FinalisationForm;